import React from "react";
import "./PostViewerModal.css";
import { FaTimes, FaHeart, FaRegHeart, FaUser, FaShare, FaEllipsisH, FaEdit, FaTrash, FaThumbtack } from "react-icons/fa";
import PostComments from "./PostComments";
import { useEffect, useState } from "react";
import { deleteRequest, patchRequest } from "../http/api";
import { useConfirmModal } from "../components/reusable/ConfirmModalContext";
import { useTranslation } from "react-i18next";
import { API_URL, UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";
import { createPortal } from "react-dom";


export default function PostViewerModal({
    post,
    onClose,
    id_user,
    highlightedCommentId,

    refreshPosts,
    setPosts,

    likes,
    liked,
    comments,
    shares,

    handleLike,
    handleShare,

    commentsLoading,
    commentsList,
    commentListRef,

    formatDate,

    editingCommentId,
    editedCommentText,
    setEditedCommentText,
    setEditingCommentId,
    handleSaveComment,

    confirmDeleteComment,
    handleTogglePin,
    handleEditComment,

    replyingTo,
    replyingUser,
    setReplyingTo,
    setReplyingUser,

    replyText,
    setReplyText,

    handleReply,

    expandedReplies,
    setExpandedReplies,

    handleLikeComment,

    renderReplyItem,

    newComment,
    setNewComment,
    handleAddComment,

    scrollToLastComment = false,
    showShareModal,
    setShowShareModal,
    matches,
    handleSharePost,
    setSelectedUsers,
    shareError,
    setShareError,
    closeShareModal
}) {


    const {
        openConfirmModal,
        closeModal
    } = useConfirmModal();

    const { t } = useTranslation();

    const [showFullCaption, setShowFullCaption] = useState(false);

    const [showMenu, setShowMenu] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const [editedText, setEditedText] = useState(
        post?.text || ""
    );
    const [showEditModal, setShowEditModal] =
        useState(false);

    const [shareToast, setShareToast] = useState(false);


    const handlePinPost = async () => {

        try {

            await patchRequest(
                `posts/${post.id_post}/pin`
            );

            refreshPosts();

            setShowMenu(false);


        }
        catch (err) {

            console.log(err);

            if (
                err.message === "MAX_3_POSTS"
            ) {

                setShareToast(true);

                setTimeout(() => {

                    setShareToast(false);

                }, 2500);

            }

        }

    };





    const handleDeletePost = () => {

        openConfirmModal({

            title: t("postViewer.deletePost.title"),
            message: t("postViewer.deletePost.message"),
            confirmText: t("postViewer.deletePost.confirm"),
            variant: "danger",
            cancelText: t("postViewer.deletePost.cancel"),

            onConfirm: async () => {

                try {

                    await deleteRequest(
                        `posts/${post.id_post}`
                    );

                    closeModal();
                    onClose();
                    refreshPosts();

                }
                catch (err) {

                    console.error(err);

                }

            }

        });

    };



    const handleEditPost = async () => {

        try {

            await patchRequest(
                `posts/${post.id_post}`,
                {
                    text: editedText
                }
            );

            post.text = editedText;

            setEditMode(false);
            setShowMenu(false);

        }
        catch (err) {

            console.error(err);

        }

    };


    const handleSaveEdit = async () => {

        try {

            await patchRequest(
                `posts/${post.id_post}`,
                {
                    text: editedText
                }
            );


            setShowEditModal(false);

            refreshPosts();

        }
        catch (err) {

            console.error(err);

        }

    }



    useEffect(() => {

        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        };

    }, []);


    if (!post) return null;


    return (
        <div className="pv-overlay" onClick={onClose}>

            <div
                className="pv-modal"
                onClick={(e) => e.stopPropagation()}
            >

                {/* CLOSE */}
                <button
                    className="pv-close"
                    onClick={onClose}
                >
                    <FaTimes />
                </button>

                {/* LEFT */}
                <div className="pv-left">

                    {post.image && (
                        <img
                            src={getMediaUrl(post.image)}
                            // src={`${UPLOADS_URL}/${post.image}`}
                            alt=""
                            className="pv-media"
                        />
                    )}

                    {post.video && (
                        <video
                            src={getMediaUrl(post.video, "video")}
                            // src={`${UPLOADS_URL}/videos/${post.video}`}
                            controls
                            className="pv-media"
                        />
                    )}

                </div>

                {/* RIGHT */}
                <div className="pv-right">

                    {/* CAPTION */}
                    <div className={`pv-caption ${showFullCaption ? "expanded" : ""}`}>

                        {post?.user_photo ? (
                            <img
                                src={getMediaUrl(post.user_image)}
                                alt=""
                                className="pv-caption-avatar"
                            />
                        ) : (
                            <FaUser
                                style={{
                                    width: "30px",
                                    height: "30px"
                                }}
                            />
                        )}
                        <div className="pv-caption-content">
                            <strong>
                                {post.username}
                            </strong>

                            {editMode ? (

                                <div>

                                    <textarea
                                        value={editedText}
                                        onChange={(e) =>
                                            setEditedText(
                                                e.target.value
                                            )
                                        }
                                    />

                                    <button
                                        onClick={handleEditPost}
                                    >
                                        {t("postViewer.actions.save")}
                                    </button>

                                </div>

                            ) : (

                                post?.text?.trim() && (
                                    <div className="pv-caption-text">

                                        {showFullCaption ? (

                                            <div className="caption-scroll">

                                                <p>
                                                    {post.text}
                                                </p>

                                            </div>

                                        ) : (

                                            <p className="collapsed">
                                                {post.text}
                                            </p>

                                        )}

                                        {post.text?.length > 180 && (
                                            <button
                                                className="pv-see-more"
                                                onClick={() =>
                                                    setShowFullCaption(!showFullCaption)
                                                }
                                            >
                                                {showFullCaption
                                                    ? t("seeMore.hide")
                                                    : t("seeMore.show")
                                                }
                                            </button>
                                        )}

                                    </div>
                                    // <p>
                                    //     {post.text}
                                    // </p>
                                )

                            )}

                        </div>

                    </div>






                    {/* COMMENTS */}
                    <div className="pv-comments-section">

                        <PostComments
                            isViewer={true}
                            highlightedCommentId={highlightedCommentId}

                            showCommentPanel={true}
                            setShowCommentPanel={() => { }}

                            commentListRef={commentListRef}

                            commentsLoading={commentsLoading}
                            commentsList={commentsList}

                            formatDate={formatDate}

                            editingCommentId={editingCommentId}
                            editedCommentText={editedCommentText}

                            setEditedCommentText={setEditedCommentText}
                            setEditingCommentId={setEditingCommentId}

                            handleSaveComment={handleSaveComment}

                            id_user={id_user}

                            post={post}

                            confirmDeleteComment={confirmDeleteComment}

                            handleTogglePin={handleTogglePin}
                            handleEditComment={handleEditComment}

                            replyingTo={replyingTo}
                            replyingUser={replyingUser}

                            setReplyingTo={setReplyingTo}
                            setReplyingUser={setReplyingUser}

                            replyText={replyText}
                            setReplyText={setReplyText}

                            handleReply={handleReply}

                            expandedReplies={expandedReplies}
                            setExpandedReplies={setExpandedReplies}

                            handleLikeComment={handleLikeComment}

                            renderReplyItem={renderReplyItem}

                            newComment={newComment}
                            setNewComment={setNewComment}

                            handleAddComment={handleAddComment}

                            FaHeart={FaHeart}

                            scrollToLastComment={scrollToLastComment}
                        />

                    </div>

                    {/* ACTIONS */}
                    <div className="pv-actions">

                        <div className="pv-actions-top">

                            <button
                                key={liked ? "liked" : "not-liked"}
                                className={`pv-action-btn pv-like-btn ${liked ? "active just-liked" : ""}`}
                                onClick={handleLike}
                            >
                                {liked
                                    ? <FaHeart />
                                    : <FaRegHeart />
                                }
                            </button>

                            <button
                                className="pv-action-btn"
                                onClick={() => setShowShareModal(true)}
                            >
                                <FaShare />
                            </button>

                            {
                                Number(post.id_user) === Number(id_user) && (
                                    <div className="pv-owner-actions">
                                        <button
                                            className="pv-menu-btn"
                                            onClick={() => setShowMenu(true)}
                                        >
                                            <FaEllipsisH />
                                        </button>
                                    </div>
                                )
                            }

                        </div>

                        <div className="pv-stats">
                            <strong>{likes}</strong> {t("postViewer.likes.count")}
                        </div>

                    </div>



                </div>

            </div>

            {showShareModal && createPortal(
                <div className="send-post-modal-overlay" onClick={closeShareModal}>

                    <div
                        className="send-post-modal send-post-share-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="send-post-share-header">
                            <span><FaShare /></span>
                            <div>
                                <h3>{t("postViewer.share.title")}</h3>
                                <p>{t("post.shareSubtitle")}</p>
                            </div>
                            <button type="button" className="send-post-share-close" onClick={closeShareModal} aria-label={t("postViewer.actions.cancel")}>
                                <FaTimes />
                            </button>
                        </div>

                        <div className="send-post-share-list">

                            {matches.length === 0 ? (
                                <p>{t("postViewer.share.noMatches")}</p>
                            ) : (

                                matches.map(user => (
                                    <div key={user.id} className="send-post-share-item">

                                        <label>
                                            <input
                                                type="checkbox"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedUsers(prev => [...prev, user.id]);
                                                    } else {
                                                        setSelectedUsers(prev =>
                                                            prev.filter(id => id !== user.id)
                                                        );
                                                    }
                                                    setShareError("");
                                                }}
                                            />

                                            {user.full_name}
                                        </label>

                                    </div>
                                ))

                            )}

                        </div>

                        {shareError && <p className="send-post-share-error">{shareError}</p>}

                        <div className="send-post-modal-actions">

                            <button onClick={closeShareModal}>
                                {t("postViewer.actions.cancel")}
                            </button>

                            <button onClick={handleSharePost}>
                                {t("postViewer.share.send")}
                            </button>

                        </div>

                    </div>

                </div>
            , document.body)}

            {showMenu && (

                <div
                    className="pv-action-modal-overlay"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowMenu(false);
                    }}
                >


                    <div
                        className="pv-action-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div
                            className="pv-action-handle"
                        />

                        <button
                            className="pv-modal-action"
                            onClick={() => {

                                setEditedText(
                                    post?.text || ""
                                );

                                setShowMenu(false);

                                setShowEditModal(true);

                            }}
                        >

                            <FaEdit />

                            {t("postViewer.actions.edit")}

                        </button>


                        <button
                            className="pv-modal-action"
                            onClick={handlePinPost}
                        >

                            <FaThumbtack />

                            {post.is_pinned
                                ? t("postViewer.actions.unpin")
                                : t("postViewer.actions.pin")}

                        </button>


                        <button
                            className="pv-modal-action delete"
                            onClick={() => {

                                setShowMenu(false);

                                handleDeletePost();

                            }}
                        >
                            <FaTrash />
                            {t("postViewer.actions.delete")}

                        </button>


                        <button
                            className="pv-modal-cancel"
                            onClick={() =>
                                setShowMenu(false)
                            }
                        >

                            {t("postViewer.actions.cancel")}

                        </button>

                    </div>

                </div>

            )}


            {showEditModal && (

                <div
                    className="modal-overlay pv-edit-post-overlay"
                    onClick={(e) => {
                        setShowEditModal(false);
                        e.stopPropagation()
                    }
                    }
                >

                    <div
                        className="modal edit-post-modal pv-edit-post-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <h3>
                            {t("postViewer.editPost.title")}
                        </h3>

                        <textarea
                            value={editedText}
                            onChange={(e) =>
                                setEditedText(
                                    e.target.value
                                )
                            }
                            className="edit-textarea"
                        />

                        {post.image && (

                            <img
                                src={getMediaUrl(post.image)}
                                // src={`${UPLOADS_URL}/${post.image}`}
                                className="edit-preview-image"
                                alt=""
                            />

                        )}

                        {post.video && (

                            <div className="edit-preview-video">

                                <video
                                    src={getMediaUrl(post.video, "video")}
                                    // src={`${UPLOADS_URL}/videos/${post.video}`}
                                    controls
                                />

                            </div>

                        )}

                        <div className="modal-actions">

                            <button
                                className="cancel"
                                onClick={() =>
                                    setShowEditModal(false)
                                }
                            >
                                {t("postViewer.actions.cancel")}
                            </button>

                            <button
                                className="publish"
                                onClick={handleSaveEdit}
                            >
                                {t("postViewer.actions.save")}
                            </button>

                        </div>

                    </div>

                </div>

            )}

            {shareToast && (

                <div className="share-success-toast">

                    <div className="share-success-icon">
                        ✕
                    </div>

                    <div>

                        <strong>
                            {t("postViewer.pinError.title")}
                        </strong>

                        <p>
                            {t("postViewer.pinError.message")}
                        </p>

                    </div>
                </div>
            )}
        </div>
    );
}
